/*
  Midnight Longhouse: pure helper functions.
  No DOM access in this file so the maths can be unit-tested with node.
  All money values are integers in the smallest currency unit (cents).
*/
(function (root) {
  'use strict';

  function addThousands(intStr, sep) {
    return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  }

  /*
    Formats cents using a Shopify money format string such as "${{amount}}".
    Supports the placeholders Shopify documents for money formats.
  */
  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = Math.round(Number(cents) || 0);
    var negative = value < 0;
    value = Math.abs(value);

    function build(decimals, thousands, decimalSep) {
      var amount;
      if (decimals === 0) {
        amount = String(Math.round(value / 100));
        return addThousands(amount, thousands);
      }
      var whole = Math.floor(value / 100);
      var frac = String(value % 100);
      if (frac.length < 2) frac = '0' + frac;
      return addThousands(String(whole), thousands) + decimalSep + frac;
    }

    var out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount':
          return build(2, ',', '.');
        case 'amount_no_decimals':
          return build(0, ',', '.');
        case 'amount_with_comma_separator':
          return build(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return build(0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return build(2, "'", '.');
        case 'amount_no_decimals_with_space_separator':
          return build(0, ' ', '.');
        case 'amount_with_space_separator':
          return build(2, ' ', ',');
        case 'amount_with_period_and_space_separator':
          return build(2, ' ', '.');
        default:
          return '';
      }
    });
    return negative ? '-' + out : out;
  }

  /*
    items: [{ price, compare_at }]   price / compare_at in cents. compare_at may be 0/null.
    opts:  { percent, minItems }     optional merchant-entered bundle percentage.
    Returns totals. bundleDiscount is only an *informational* figure: the theme cannot apply it.
  */
  function bundleTotals(items, opts) {
    opts = opts || {};
    var count = 0;
    var total = 0;
    var original = 0;
    (items || []).forEach(function (it) {
      var price = Math.round(Number(it.price) || 0);
      var cmp = Math.round(Number(it.compare_at) || 0);
      count += 1;
      total += price;
      original += cmp > price ? cmp : price;
    });
    var percent = Number(opts.percent) || 0;
    var minItems = Number(opts.minItems) || 2;
    var bundleDiscount = 0;
    if (percent > 0 && percent <= 100 && count >= minItems) {
      bundleDiscount = Math.round((total * percent) / 100);
    }
    return {
      count: count,
      total: total,
      original: original,
      saleSavings: original - total,
      bundleDiscount: bundleDiscount,
      totalAfterDiscount: total - bundleDiscount,
    };
  }

  /*
    Free-shipping progress.
    totalCents:     cart.total_price (presentment currency, cents)
    thresholdCents: merchant threshold in SHOP currency, cents
    rate:           presentment/shop exchange rate (1 when same currency)
  */
  function freeShippingState(totalCents, thresholdCents, rate) {
    var threshold = Math.round(Number(thresholdCents) || 0);
    var r = Number(rate);
    if (!isFinite(r) || r <= 0) r = 1;
    if (threshold <= 0) {
      return { enabled: false, threshold: 0, remaining: 0, percent: 0, reached: false };
    }
    var thr = Math.round(threshold * r);
    var total = Math.max(0, Math.round(Number(totalCents) || 0));
    var remaining = Math.max(0, thr - total);
    var percent = Math.min(100, Math.floor((total / thr) * 100));
    return { enabled: true, threshold: thr, remaining: remaining, percent: percent, reached: total >= thr };
  }

  /* Sticky add-to-cart: show only once the main button has scrolled off the TOP of the viewport. */
  function shouldShowSticky(rect, viewportHeight) {
    if (!rect) return false;
    if (rect.width === 0 && rect.height === 0) return false;
    return rect.bottom <= 0 && viewportHeight > 0;
  }

  /* Collapse duplicate variant ids into one line each. */
  function buildAddItems(variantIds) {
    var order = [];
    var qty = {};
    (variantIds || []).forEach(function (id) {
      var key = String(id);
      if (!key || key === 'undefined' || key === 'null') return;
      if (!qty[key]) {
        qty[key] = 0;
        order.push(key);
      }
      qty[key] += 1;
    });
    return order.map(function (key) {
      return { id: Number(key), quantity: qty[key] };
    });
  }

  function buildDiscountUrl(method, code, checkoutUrl) {
    var clean = String(code || '').trim();
    if (!clean) return checkoutUrl;
    var enc = encodeURIComponent(clean);
    if (method === 'discount_link') {
      return '/discount/' + enc + '?redirect=' + encodeURIComponent(checkoutUrl);
    }
    return checkoutUrl + (checkoutUrl.indexOf('?') === -1 ? '?' : '&') + 'discount=' + enc;
  }

  function substitute(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(values, k) ? values[k] : m;
    });
  }

  var api = {
    formatMoney: formatMoney,
    bundleTotals: bundleTotals,
    freeShippingState: freeShippingState,
    shouldShowSticky: shouldShowSticky,
    buildAddItems: buildAddItems,
    buildDiscountUrl: buildDiscountUrl,
    substitute: substitute,
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  } else {
    root.MLCore = api;
  }
})(typeof window !== 'undefined' ? window : this);
